// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import Storage from 'vue-ls'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import { Button, message, Icon } from 'ant-design-vue'; 
import api from '@/api/api'
import mobileApi from '@/api/mobileApi'
//noinspection ES6UnusedImports
import Bulma from 'bulma'

Vue.config.productionTip = false

// Vue.use(Button).use(Icon);
Vue.use(Antd);
Vue.use(Storage, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
})
Vue.prototype.$message = message;
Vue.prototype.$api = api;
Vue.prototype.$mobile = mobileApi

/* eslint-disable no-new */
let vm = new Vue({
  // el: '#editor',
  el: '#app',
  router: router,
  render: h => h(App)
  // template: '<Editor ref="editor"/>',
  // components: {Editor}
})


// WEBPACK FOOTER //
// ./src/main.js